module.exports = __webpack_public_path__ + "img/隨緣自強4 的副本.4a6ec7fa.jpg";